<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <name />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <email />
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <team-status />
        </b-col>
        <b-col>
          <b-form-group
            label="Ekip Pozisyonu"
            label-for="id_team_types"
          >
            <v-select
              id="id_team_types"
              v-model="dataItem.id_team_types"
              :options="team_types"
              label="title"
              :reduce="item => item.id"
              placeholder="Ekip Pozisyonu"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

<!--    <image-card />-->
    <image-file />
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>

  </div>
</template>

<script>
import {
  BCard,
  BFormInput, BFormGroup, BRow, BCol, BButton,
} from 'bootstrap-vue'

import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import team_types from '@/store/Admin/Defines/team_types'
import Name from '@/views/Admin/Teams/elements/Name.vue'
import Email from '@/views/Admin/Teams/elements/Email.vue'
import TeamStatus from '@/views/Admin/Teams/elements/TeamStatus.vue'
// import ImageCard from '@/views/Admin/Teams/elements/ImageCard.vue'
import ImageFile from '@/views/Admin/Teams/elements/ImageFile.vue'
// import ImageFileCard from '@/views/Admin/Teams/elements/ImageFile.vue'

export default {
  name: 'TeamTypesForm',
  components: {
    BButton,
    // ImageFileCard,
    Name,
    Email,
    TeamStatus,
    // ImageCard,
    ImageFile,
    vSelect,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    BCard,
    BRow,
    BCol,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    team_types() {
      return this.$store.getters['teamTypes/dataList']
    },
    dataItem() {
      return this.$store.getters['teams/dataItem']
    },

  },
  created() {
    this.getTeamTypes()
  },
  methods: {
    getTeamTypes() {
      this.$store.dispatch('teamTypes/getDataList', {
        select: [
          'team_types.id AS id',
          'team_types.title AS title',
        ],
      })
    },

  },
}
</script>
